// import { fieldset } from "@/ui/theme";
const fieldset = {}

export default { fieldset };
